import type { IconProps } from '@src/components/icons/IconProps';

export function MailIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="3" y="5" width="18" height="14" rx="2.5" />
      <path d="m4 7.5 7.2 5.1a1.4 1.4 0 0 0 1.6 0L20 7.5" />
    </svg>
  );
}
